/** Cognito / backend auth error message helpers (parity with Flutter auth_error_helpers.dart). */

export const isDuplicateSignUpError = (message: string): boolean => {
  const lower = message.toLowerCase();
  return (
    message.includes('PreSignUpEmailExistsError') ||
    lower.includes('user already exists') ||
    lower.includes('usernameexists') ||
    lower.includes('account already exists') ||
    lower.includes('email already exists') ||
    lower.includes('account with this email already exists')
  );
};

export const isAlreadyConfirmedResendError = (message: string): boolean => {
  const lower = message.toLowerCase();
  return (
    lower.includes('already confirmed') ||
    lower.includes('user is confirmed') ||
    lower.includes('confirmed user') ||
    lower.includes('current status is confirmed')
  );
};

export const isUnconfirmedAccountError = (message: string): boolean => {
  const lower = message.toLowerCase();
  return (
    lower.includes('not confirmed') ||
    lower.includes('unconfirmed') ||
    lower.includes('not verified') ||
    lower.includes('usernotconfirmed')
  );
};

/** Backend ConflictException when the email belongs to a confirmed password account. */
export const isConfirmedExistingAccountSignUpError = (message: string): boolean => {
  const lower = message.toLowerCase();
  return (
    lower.includes('sign in with your password') ||
    lower.includes('use password reset') ||
    lower.includes('password reset if you forgot')
  );
};

export const isGoogleOnlyAccountSignUpError = (message: string): boolean => {
  const lower = message.toLowerCase();
  return lower.includes('google sign-in') || lower.includes('sign in with google');
};

export const isConfirmedExistingAccountResendError = (message: string): boolean => {
  return isAlreadyConfirmedResendError(message) || isConfirmedExistingAccountSignUpError(message);
};

/** Duplicate signup where recovery should resend verification (unconfirmed only). */
export const shouldRecoverUnverifiedSignUp = (message: string): boolean => {
  if (!isDuplicateSignUpError(message)) return false;
  if (isConfirmedExistingAccountSignUpError(message)) return false;
  // Backend may mislabel unconfirmed email duplicates as Google-only — still try resend.
  if (isGoogleOnlyAccountSignUpError(message)) return true;
  return true;
};
